module.exports = __webpack_public_path__ + "151cc9e66f8683f5cb780a66c6682539.png";